import React, { useCallback } from "react";
import { connect } from "react-redux";

import { EntitiesSupportingMultiPin, MapEntity } from "@mapmycustomers/shared/types/entity";

import { EntityItemProperties } from "@app/component/RecordCard";
import EntityCard from "@app/component/RecordCard/components/EntityCard";
import { showEntityView } from "@app/store/entityView/actions";
import { RootState } from "@app/store/rootReducer";

import { isMultiPinRecordsListSortedByDistance } from "./store/selectors";

interface Props extends EntityItemProperties<EntitiesSupportingMultiPin> {
  showEntityView: typeof showEntityView;
  sortedByDistance?: boolean;
}

const EntityItem: React.FC<Props> = ({
  entity,
  fieldsComparator,
  overrideFieldVisibility,
  showEntityView,
  sortedByDistance,
}) => {
  const handleClick = useCallback(() => {
    showEntityView({
      entityId: entity.id,
      entityType: entity.entity,
    });
  }, [entity, showEntityView]);

  return (
    <EntityCard
      entity={entity as MapEntity}
      fieldsComparator={fieldsComparator}
      onClick={handleClick}
      overrideFieldVisibility={overrideFieldVisibility}
      showDistance={sortedByDistance}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  sortedByDistance: isMultiPinRecordsListSortedByDistance(state),
});

const mapDispatchToProps = {
  showEntityView,
};

export default connect(mapStateToProps, mapDispatchToProps)(EntityItem);
